import { Flex, Image, Link } from '@chakra-ui/react';
import { FaPhoneAlt } from '@react-icons/all-files/fa/FaPhoneAlt';

import { Logo } from '../assets/Images';
import { MKT_HOME } from '../constants/urls';
import getSearchPhoneNumbers from '../utils/getSearchPhoneNumbers';

const MobileNavFlow = () => {
  const phoneNumber = getSearchPhoneNumbers();

  return (
    <Flex
      position="relative"
      justifyContent="center"
      alignItems="center"
      m="0 -15px 0 -2em"
      p={3}
      bgColor="white"
      zIndex={1000}
    >
      <Link href={MKT_HOME}>
        <Image w="135px" src={Logo} alt="Lease End Logo" />
      </Link>
      <Link
        position="absolute"
        top="50%"
        right="20px"
        transform="translateX(-50%) translateY(-50%)"
        href={`tel:+1-${phoneNumber}`}
        textDecoration="none"
        fontSize="2rem"
        aria-label="Phone Number"
      >
        <FaPhoneAlt />
      </Link>
    </Flex>
  );
};

export default MobileNavFlow;
